export default __webpack_public_path__ + "static/trustflight-logo-white-60ca034cfbbee550c4aa049b50b82147.svg";